import { IBudgetUnitAddEditRequest } from '../../../../model/sge/budget-unit/request/budget-unit-add-edit-request';

export type BudgetUnitCreateEditState = {
    budgetUnitId?: string;
    budgetUnitRequest: IBudgetUnitAddEditRequest;
    showValidationErrors: boolean;
};

export enum ACTION_TYPES {
    setBudgetUnitId = 'setBudgetUnitId',
    setBudgetUnitRequest = 'setBudgetUnitRequest',
    updateBudgetUnitRequest = 'updateBudgetUnitRequest',
    setShowValidationErrors = 'setShowValidationErrors',
}

export const BudgetUnitCreateEditReducer = (state: BudgetUnitCreateEditState, action: any): BudgetUnitCreateEditState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setBudgetUnitId:
            return { ...state, budgetUnitId: payload };
        case ACTION_TYPES.setBudgetUnitRequest:
            return { ...state, budgetUnitRequest: payload };
        case ACTION_TYPES.updateBudgetUnitRequest:
            return { ...state, budgetUnitRequest: { ...state.budgetUnitRequest, ...payload } };
        case ACTION_TYPES.setShowValidationErrors:
            return { ...state, showValidationErrors: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
